// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1OpUO","rootSuccess":"CompleteLink_rootSuccess__3dn1r","rootFailure":"CompleteLink_rootFailure__2XhMx","isDisabled":"CompleteLink_isDisabled__2-Xfn"};